import { Button, Dropdown, Space } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { useEffect, useRef, useState } from 'react'
import Iconfont from '@utils/Iconfont'
import Utils from '@utils/utils'
import PSAIModal from '@PSAIComponents/PSAIModal'
import PickFromProject from '@view/page_v3/AiEdit/components/PickFromProject'
import DragAndScale from '../dragAndScale/dragAndScale'
import styles from './index.module.scss'

const BottomPlaceholder = ({ config, loading, visible, enableProjectReupload, onProjectImageChange }) => {
    const {
        compare,
        revoke,
        restore,
        reset,
        remove,
        download,
        uploadCb,
        scale,
        customContent
    } = config || {}

    const projectListRef = useRef()
    const [openProjectModal, setOpenProjectModal] = useState(false)
    const [downloadLoading, setDownloadLoading] = useState(false)

    const onUpload = (file) => {
        uploadCb && uploadCb(file)
        return false
    }

    const reuploadItems = [
        { label: '本地上传', key: 'local' },
        { label: '从项目选图', key: 'project' },
    ]

    const handleReuploadClick = (e) => {
        const status = Utils.checkLoginStatus(() => handleReuploadClick(e))
        if (!status) return
        if (e.key === 'local') {
            Utils.openFile2(false).then(onUpload).catch(() => { })
            return
        }
        setOpenProjectModal(true)
    }

    const handleProjectOk = async () => {
        const url = await projectListRef.current?.onSubmit?.()
        if (!url) return false
        setOpenProjectModal(false)
        onProjectImageChange && onProjectImageChange(url)
    }

    const handleProjectDoubleClick = (url) => {
        if (!url) return
        setOpenProjectModal(false)
        onProjectImageChange && onProjectImageChange(url)
    }

    const downloadClickEmit = async () => {
        if (!download?.trigger || downloadLoading) return
        setDownloadLoading(true)
        try {
            await download.trigger()
        } finally {
            setDownloadLoading(false)
        }
    }

    const revokeDisabled = useRef(true)
    const revokeTrigger = useRef()
    useEffect(() => {
        if (revoke) {
            revokeDisabled.current = revoke.disabled
            revokeTrigger.current = revoke.trigger
        } else {
            revokeDisabled.current = true
            revokeTrigger.current = null
        }
    }, [revoke])

    useEffect(() => {
        const handleUndo = (event) => {
            if (event.ctrlKey && event.key == 'z') {
                if (revokeTrigger.current && !revokeDisabled.current) {
                    revokeTrigger.current()
                }
            }
        }
        document.addEventListener('keydown', handleUndo)
        return () => {
            document.removeEventListener('keydown', handleUndo)
        }
    }, [])

    return visible ? (
        <div className={styles.BottomPlaceholder}>
            <div className={styles.LeftSpace}></div>
            <div className={styles.ContentArea}>
                {
                    loading && !config &&
                    <div className={`${styles.Inner} ${styles.LoadingInner}`}>
                        <span className={styles.LoadingBar}></span>
                        <span className={styles.LoadingBar}></span>
                        <span className={styles.LoadingBar}></span>
                    </div>
                }
                {
                    !loading && config &&
                    <div className={styles.Inner}>
                        {
                            customContent ? customContent : <div className={styles.ToolRow}>
                    <div className={styles.BtnGroup}>
                        {
                            revoke && <div
                                className={`${styles.ToolItem} ${revoke.disabled ? styles.ToolItemDisabled : ''}`}
                                onClick={revoke.disabled ? undefined : revoke.trigger}
                            >
                                <Iconfont
                                    type="icon-RollbackOutlined"
                                    className={styles.ActionIconMuted}
                                />
                                <span>撤销</span>
                            </div>
                        }
                        {
                            restore && <div
                                className={`${styles.ToolItem} ${restore.disabled ? styles.ToolItemDisabled : ''}`}
                                onClick={restore.disabled ? undefined : restore.trigger}
                            >
                                <Iconfont
                                    type="icon-uncancel"
                                    className={styles.ActionIconMuted}
                                />
                                <span>恢复</span>
                            </div>
                        }
                        {
                            reset && <div
                                className={`${styles.ToolItem} ${reset.disabled ? styles.ToolItemDisabled : ''}`}
                                onClick={reset.disabled ? undefined : reset.trigger}
                            >
                                <Iconfont
                                    type="icon-RedoOutlined"
                                    className={styles.ActionIconMuted}
                                />
                                <span>重置</span>
                            </div>
                        }
                    </div>
                    <span className={styles.Divider}></span>
                    <div className={styles.ScaleBox}>
                        {
                            scale &&
                            <DragAndScale
                                ref={scale.ref}
                                zoomAllowed={scale.zoomAllowed}
                                min={scale.min}
                                max={scale.max}
                                onChange={scale.onChange}
                                canvasList={scale.canvasList}
                                disabled={scale.disabled}
                                options={scale.options}
                            />
                        }
                    </div>
                    <div className={styles.BtnGroup}>
                        {
                            compare && <div
                                className={`${styles.ToolItem} ${compare.disabled ? styles.ToolItemDisabled : ''}`}
                                onClick={compare.disabled ? undefined : compare.trigger}
                            >
                                <Iconfont type="icon-comparison" className={styles.CompareIcon} />
                                <span>对比</span>
                            </div>
                        }
                    <span className={styles.Divider}></span>

                        {
                            remove && <div
                                className={`${styles.ToolItem} ${remove.disabled ? styles.ToolItemDisabled : ''}`}
                                onClick={remove.disabled ? undefined : remove.trigger}
                            >
                                <Iconfont type="icon-Material-DeleteOutlined" className={styles.DeleteIcon} />
                                <span>删除</span>
                            </div>
                        }
                    </div>
                    <span className={styles.Divider}></span>
                    <div className={styles.ActionGroup}>
                        <div className={styles.ReuploadBox}>
                            {
                                enableProjectReupload ? (
                                    <Dropdown trigger={['click']} menu={{ items: reuploadItems, onClick: handleReuploadClick }} overlayClassName={styles.Dropdown}>
                                        <Button className={styles.BtnPrimary}>
                                            <Space>
                                                重新上传
                                                <DownOutlined className={styles.DropIcon} />
                                            </Space>
                                        </Button>
                                    </Dropdown>
                                ) : (
                                    <Button className={styles.BtnPrimary} onClick={() => Utils.openFile2(false).then(onUpload).catch(() => { })}>重新上传</Button>
                                )
                            }
                        </div>
                        {
                            download &&
                            <Button
                                disabled={download.disabled || downloadLoading}
                                loading={downloadLoading}
                                className={styles.BtnPrimary}
                                type='primary'
                                onClick={downloadClickEmit}
                            >
                                下载图片
                            </Button>
                        }
                    </div>
                </div>
                        }
                    </div>
                }
            </div>
            <PSAIModal
                open={openProjectModal}
                maxWidth={980}
                title="选择图片"
                onOk={handleProjectOk}
                onCancel={() => setOpenProjectModal(false)}
            >
                <PickFromProject
                    ref={projectListRef}
                    onDoubleClick={handleProjectDoubleClick}
                    showAllType
                />
            </PSAIModal>
        </div>
    ) : null
}

export default BottomPlaceholder
